import { Route, Routes } from "react-router-dom";

import {
  AmortizationForm,
  BudgetForm,
  BuyerQualFormV2 as BuyerQualForm,
  ConsumerDebtForm,
  EquityForm,
  HecmForm,
  InvestmentForm,
  BuyerChoiceFormV2,
  BuyOrRentFormV2 as BuyOrRentForm,
  BuyWaitForm,
  ClosingCostForm,
  PaymentSubsidyForm,
  SellerNetForm,
  VacationFormV2 as VacationForm,
  BuyerChoiceFormQuick,
  BuyerQualFormQuick,
} from "@ask-christee/ui-response";

import {
  Home as HomeView,
  HomeIconGrid as HomeIconGridView,
} from "../src/components/pages";
import { useGAPageView } from "./hooks";
import { ModuleLayout } from "./components/molecules";

const AppRoutes = () => {
  useGAPageView();

  return (
    <Routes>
      <Route path="/" exact element={<HomeView />} />
      <Route path="/modules" exact element={<HomeIconGridView />} />
      <Route element={<ModuleLayout />}>
        <Route path="/amortization" exact element={<AmortizationForm />} />
        <Route path="/buyer-prequal" exact element={<BuyerQualForm />} />
        <Route
          path="/buyer-prequal/quick"
          exact
          element={<BuyerQualFormQuick />}
        />
        <Route path="/buyer-choice" exact element={<BuyerChoiceFormV2 />} />
        <Route
          path="/buyer-choice/quick"
          exact
          element={<BuyerChoiceFormQuick />}
        />
        <Route path="/buy-or-wait" exact element={<BuyWaitForm />} />
        <Route path="/buy-or-rent" exact element={<BuyOrRentForm />} />
        <Route path="/budget" exact element={<BudgetForm />} />
        <Route path="/closing-cost" exact element={<ClosingCostForm />} />
        <Route path="/equity" exact element={<EquityForm />} />
        <Route path="/reverse" exact element={<HecmForm />} />
        <Route path="/investment" exact element={<InvestmentForm />} />
        <Route path="/seller-net" exact element={<SellerNetForm />} />
        <Route path="/vacation" exact element={<VacationForm />} />
        <Route path="/consumer-debt" exact element={<ConsumerDebtForm />} />
        <Route path="/subsidy" exact element={<PaymentSubsidyForm />} />
      </Route>
    </Routes>
  );
};
export default AppRoutes;
